module.exports = __webpack_public_path__ + "static/img/5-1.4e4f304.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/5-1.png
// module id = 9Lgh
// module chunks = 25